export default __webpack_public_path__ + "static/spread-34917df9a0a6304469f6cb358322cf84.png";